const page = 'StatisticsPage';

export default page;
